import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["items", "id", "titleId"];
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Menu, MenuButton, MenuList, MenuItem } from 'components/Menu';
function ActionButtonMenu(_ref) {
  var items = _ref.items,
    id = _ref.id,
    titleId = _ref.titleId,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Menu, {
    id: id,
    menuPlacement: "bottom-end"
  }, /*#__PURE__*/React.createElement(MenuButton, _extends({
    variant: "transparent",
    icon: "tools",
    iconOnly: true,
    "aria-labelledby": "controller-".concat(id, " ").concat(titleId)
  }, otherProps), t('actions')), /*#__PURE__*/React.createElement(MenuList, null, items.map(function (_ref2) {
    var value = _ref2.value,
      icon = _ref2.icon,
      onSelect = _ref2.onSelect;
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: value,
      icon: icon,
      onClick: onSelect
    }, value);
  })));
}
export default ActionButtonMenu;